module.exports = __webpack_public_path__ + "img/IBV_white.590306b1.png";